import React from 'react'
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import IconButton, {IconButtonProps} from '@mui/material/IconButton';
import {useLocation} from "react-router-dom"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const {expand, ...other} = props;
    return <IconButton {...other} />;
})(({theme, expand}) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

interface PricingProps {
    onSignUpClick?: (index: number) => void;
}

const Pricing: React.FC<PricingProps> = ({onSignUpClick}) => {

    const location = useLocation()
    const [open1, setOpen1] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);
    const [open4, setOpen4] = React.useState(false);
    const [selectedSignUpIndex, setSelectedSignUpIndex] = React.useState<number | null>(null);

    const handleSignUpButtonClicked = (index: number) => {
        setSelectedSignUpIndex(prevIndex => prevIndex === index ? null : index);
        onSignUpClick && onSignUpClick(index);
    };

    const handleClickOpen1 = () => {
        setOpen1(true);
    };
    const handleClickOpen2 = () => {
        setOpen2(true);
    };
    const handleClickOpen3 = () => {
        setOpen3(true);
    };
    const handleClickOpen4 = () => {
        setOpen4(true);
    };
    // --------------------------//
    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleClose2 = () => {
        setOpen2(false);
    };
    const handleClose3 = () => {
        setOpen3(false);
    };
    const handleClose4 = () => {
        setOpen4(false);
    };


    return (
        <div className='pricing-section' id="pricing-section">
            <Container>
                {location.pathname !== "/register" ?
                    <Typography variant="h4" gutterBottom>
                        Pricing
                    </Typography>
                    :
                    <></>

                }

                <div className='card-section'>
                    <Card className='card-pricing' sx={{maxWidth: 275}}>
                        <CardHeader className='card-header'
                                    title="Learner"
                                    subheader="$99.99BDS/yr"
                        />
                        <CardContent>
                            <Typography variant="body2" color="black">
                                This section is reserved for persons with a valid Learner's Permit and persons
                                interested in obtaining a Barbados Driver's License...
                            </Typography>
                            <BootstrapDialog
                                onClose={handleClose1}
                                aria-labelledby="customized-dialog-title"
                                open={open1}
                            >
                                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose1}>
                                    Learner
                                </BootstrapDialogTitle>
                                <DialogContent dividers>
                                    <Typography gutterBottom>
                                        This module is reserved for persons with a valid Learner's Permit and persons
                                        interested in obtaining a Barbados Driver's License,
                                        from the Barbados Licensing Authority. The information provided in this module
                                        includes hand signals, vehicle controls,
                                        simple maneuvering of a vehicle and other topics that would assist learners with
                                        preparing for the driver's test.
                                    </Typography>
                                    <Typography gutterBottom>
                                        This module also provides information about obtaining a permit, upgrading a
                                        permit and permit renewals for persons unfamiliar
                                        with the processes.
                                    </Typography>
                                </DialogContent>
                            </BootstrapDialog>
                            {/* Read {!expanded ? 'More' : 'Less'}
              <ExpandMore
                expand={expanded}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              > */}
                            <CardActions>
                                <p><strong>Read More</strong></p>
                                <IconButton onClick={handleClickOpen1}>
                                    <ExpandMoreIcon/>

                                </IconButton>
                            </CardActions>
                        </CardContent>
                        <CardActions className='button-container'>
                            <Button
                                className='sign-up-card'
                                size="large"
                                disabled={selectedSignUpIndex === 0}
                                onClick={() => handleSignUpButtonClicked(0)}
                            >
                                Sign Up
                            </Button>
                        </CardActions>
                    </Card>
                    <Card className='card-pricing' sx={{maxWidth: 275}}>
                        <CardHeader className='card-header'
                                    title="Licensed Driver"
                                    subheader="$199.99BDS/yr"
                        />
                        <CardContent>
                            <Typography variant="body2" color="black">
                                This module is for Barbadian driver's license holders. This module allows for persons to
                                build on their existing driving
                                knowledge and to become.....
                            </Typography>
                            <BootstrapDialog
                                onClose={handleClose2}
                                aria-labelledby="customized-dialog-title"
                                open={open2}
                            >
                                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose2}>
                                    Licensed Drivers
                                </BootstrapDialogTitle>
                                <DialogContent dividers>
                                    <Typography gutterBottom>
                                        This module is for Barbadian driver's license holders. This module allows for
                                        persons to build on their existing driving
                                        knowledge and to become even more vigilant and safe drivers. The content
                                        provided is ideal for persons who have driving
                                        experience but are uncertain on how to use certain roads, areas, and
                                        roundabouts.
                                    </Typography>

                                </DialogContent>
                            </BootstrapDialog>
                            <CardActions>
                                <p><strong>Read More</strong></p>
                                <IconButton onClick={handleClickOpen2}>
                                    <ExpandMoreIcon/>

                                </IconButton>
                            </CardActions>
                        </CardContent>
                        <CardActions>
                            <Button
                                className='sign-up-card'
                                size="large"
                                disabled={selectedSignUpIndex === 1}
                                onClick={() => handleSignUpButtonClicked(1)}
                            >
                                Sign Up
                            </Button>
                        </CardActions>
                    </Card>
                    <Card className='card-pricing' sx={{maxWidth: 275}}>
                        <CardHeader className='card-header'
                                    title="Driving Instructor"
                                    subheader="$299.99BDS/yr"
                        />
                        <CardContent>
                            <Typography variant="body2" color="black">
                                This module is reserved for persons interested in becoming a driving intructor.
                                The content consists of teaching materials that will equip...
                            </Typography>
                            <BootstrapDialog
                                onClose={handleClose3}
                                aria-labelledby="customized-dialog-title"
                                open={open3}
                            >
                                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose3}>
                                    Driving Instructor
                                </BootstrapDialogTitle>
                                <DialogContent dividers>
                                    <Typography gutterBottom>
                                        This module is reserved for persons interested in becoming a driving intructor.
                                        The content consists of teaching materials that will equip eligible persons with
                                        the knowledge and tools necessary to become a professional driving instructor.
                                    </Typography>

                                </DialogContent>
                            </BootstrapDialog>
                            <CardActions>
                                <p><strong>Read More</strong></p>
                                <IconButton onClick={handleClickOpen3}>
                                    <ExpandMoreIcon/>

                                </IconButton>
                            </CardActions>
                        </CardContent>
                        <CardActions>
                            <Button className='sign-up-card' size="large"
                                    onClick={() => onSignUpClick && onSignUpClick(2)}>Sign
                                Up</Button>
                        </CardActions>
                    </Card>
                    <Card className='card-pricing' sx={{maxWidth: 275}}>
                        <CardHeader className='card-header'
                                    title="Tourist"
                                    subheader="$399.99BDS/yr"
                        />
                        <CardContent>
                            <Typography variant="body2" color="black">
                                Keep an eye out for updates on this exciting new module!
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button disabled className='coming-soon' size="large">Coming Soon!</Button>
                        </CardActions>
                    </Card>
                </div>

            </Container>
        </div>
    )
}

export default Pricing